import { gql } from '@apollo/client';

const HOLTER_RR_CELLS_BEATS_QUERY = gql`
  query listHolterBeats($filter: ListHolterBeatsFilter!) {
    listHolterBeats(filter: $filter) {
      isSuccess
      message
      beats
      hesBeatStatus
      beatChannels
      totalBeats
      beatHeatMapIds
      beatReviewed
      beatTemplateIds
    }
  }
`;

export default HOLTER_RR_CELLS_BEATS_QUERY;
